import React, {
    ForwardedRef,
    PropsWithChildren,
    forwardRef,
    memo,
} from 'react';

import { StyleProp, Text, TextProps, TextStyle } from 'react-native';

import { styles, textColorStyles, textSizeStyles } from './styles';

export enum ETextCategory {
    title1 = 'title1',
    title2 = 'title2',
    title3 = 'title3',
    body1 = 'body1',
    body2 = 'body2',
    caption1 = 'caption1',
    caption2 = 'caption2',
}

export enum ETextColor {
    light_grey = 'light_grey',
    low_contrast = 'low_contrast',
    high_contrast = 'high_contrast',
    primary = 'primary',
    secondary = 'secondary',
    error = 'error',
    success = 'success',
    neutral = 'neutral',
    black = 'black',
    dark_grey = 'dark_grey',
    transparent = 'transparent',
}

type Props = PropsWithChildren<
    TextProps & {
        category?: ETextCategory;
        color?: ETextColor;
        bold?: boolean;
        center?: boolean;
    }
>;

const TextUI = forwardRef((props: Props, ref: ForwardedRef<Text>) => {
    const { category, color, bold, style, children, center, ...other } = props;

    const styleOutput: StyleProp<TextStyle>[] = buildStyles(
        category,
        color,
        bold,
        style,
        center,
    );

    return (
        <Text
            ref={ref}
            style={[styles.androidAlignement, styleOutput]}
            {...other}
        >
            {children}
        </Text>
    );
});

function buildStyles(
    category?: ETextCategory,
    color?: ETextColor,
    bold?: boolean,
    style?: StyleProp<TextStyle>,
    center?: boolean,
): StyleProp<TextStyle>[] {
    const result: StyleProp<TextStyle>[] = [];
    color && result.push(textColorStyles[color]);
    category && result.push(textSizeStyles[category]);
    bold && result.push(styles.bold);
    center && result.push(styles.center);
    style && result.push(style);

    return result;
}

export default memo(TextUI);
